import { UserLabel } from '@app/components/users/UserLabel';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box, Typography } from '@mui/material';

/**
 * Renders the fragment creator: user label and optional dot separator.
 * Renders nothing when fragment has no creator (undefined or null).
 */
export function FragmentCardCreator({
  creator,
}: {
  creator: FragmentListItemDto['creator'] | null;
}) {
  if (!creator) return null;

  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, minHeight: 20 }}
    >
      <Typography
        component="span"
        variant="caption"
        color="text.secondary"
        sx={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}
      >
        <UserLabel
          showIcon
          iconSize="small"
          id={creator.id}
          user={{
            name: creator.name ?? '',
            surname: creator.surname ?? '',
            email: creator.email ?? '',
            avatar: creator.avatar,
          }}
        />
      </Typography>
      <Typography component="span" variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
        ·
      </Typography>
    </Box>
  );
}
